import { db } from "./firebase-config";

import "firebase/database";
const collectionName = "kidney_event";

const getCollectionReferance = async () => {
    return await db.collection(collectionName);
  };

const getAllUsers = async () => {
  return (await getCollectionReferance()).get();
};

const addAction = async (age) => {
  const users = await getAllUsers();
  const newUserNum = users.docs.length+1
  const collection = await getCollectionReferance()
  collection.doc(`User ${newUserNum}`).set({age,count:newUserNum})
};

export { addAction };
